"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const useTooltip_1 = require("./useTooltip");
/**
 * Display tooltip by mouseover.
 */
function Tooltip(props) {
    return (0, useTooltip_1.useTooltip)(props);
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map